import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientDetailsPage } from './patient-details';
import { DirectivesModule } from '../../directives/directives.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentsModule } from '../../components/components.module';
import { FileUploadModule } from 'ng2-file-upload';
import { MatNativeDateModule, MatDatepickerModule,MatFormFieldModule,MatInputModule, MatSelectModule, MatOptionModule, MatExpansionModule, MatTabsModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDialogModule } from '@angular/material';

@NgModule({
  declarations: [
    PatientDetailsPage
  ],
  imports: [
    IonicPageModule.forChild(PatientDetailsPage),
    DirectivesModule,
    NgxDatatableModule,
    ComponentsModule,
    FileUploadModule,
    MatNativeDateModule, MatDatepickerModule,MatFormFieldModule,MatInputModule, MatSelectModule, MatOptionModule, MatExpansionModule, MatTabsModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDialogModule
  ],
})
export class PatientDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-details/patient-details.module.ts